import { render } from "./ZwipitModal.vue?vue&type=template&id=11df57e5"
import script from "./ZwipitModal.vue?vue&type=script&lang=js"
export * from "./ZwipitModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__